"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTRIBUTE_TYPE = void 0;
exports.ATTRIBUTE_TYPE = {
    COLOR: 'COLOR',
    SIZE: 'SIZE',
    VARIANT: 'VARIANT',
    CG_PRODUCT_VARIANT_ID: 'CG_PRODUCT_VARIANT_ID',
    CG_TEXTUAL_PRODUCT_ID: 'CG_TEXTUAL_PRODUCT_ID',
    SUBSCRIPTION_INTERVAL: 'SUBSCRIPTION_INTERVAL',
    SUBSCRIPTION_REPEAT_FREQUENCY: 'SUBSCRIPTION_REPEAT_FREQUENCY',
    DTG_CAMPAIGN_ID: 'DTG_CAMPAIGN_ID',
    DTG_PRODUCT_ID: 'DTG_PRODUCT_ID',
    ARTWORK_ORIGINAL: 'ARTWORK_ORIGINAL',
    ARTWORK_PREVIEW: 'ARTWORK_PREVIEW',
    ORDER_STATE: 'ORDER_STATE'
};
//# sourceMappingURL=attributeType.js.map